import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';
import { SideNavContext } from '../index.context';

const {
    StyledSideNavItem,
    StyledIconWrapper,
    StyledTitleWrapper,
    StyledIcon,
    StyledTitle,
} = Styles;

export const SideNavItem = ({
    id,
    title,
    icon,
    onClick,
    selectable,
    children,
    subNavItem,
    mobileNavItem,
    mobileOnly,
    collapsibleSubNavItem,
    ...otherProps
}) => {
    const handlePossibleCollapsibleNavItemsClicked = (
        mobile,
        mblOnly,
        mblNavItem,
        isSubNavItem,
        isCollapsibleSubNavItem,
        callback,
        event,
    ) => {
        const isTopLevelWithChildren = !mobile && !mblOnly && !mblNavItem && !isSubNavItem;
        const hasSubNavItems = isCollapsibleSubNavItem || isTopLevelWithChildren;
        const mustRunCallback = hasSubNavItems;

        if (mustRunCallback) {
            callback(event);
        }
    };

    return (
        <SideNavContext.Consumer>
            {({ selected, mobile, collapsedMenu, onSelect }) =>
                (mobile && (mobileNavItem || mobileOnly || subNavItem || collapsibleSubNavItem)) ||
                (!mobile && !mobileOnly) ? (
                    <StyledSideNavItem
                        title={title}
                        id={id}
                        highlithed={selected ? id === selected.id : false}
                        onClick={evt => {
                            handlePossibleCollapsibleNavItemsClicked(
                                mobile,
                                mobileNavItem,
                                mobileOnly,
                                subNavItem,
                                collapsibleSubNavItem,
                                onClick,
                                evt,
                            );

                            if (selectable) {
                                onSelect(evt, { id, children }, onClick);
                            }
                        }}
                        mobile={!subNavItem && mobile}
                        collapsibleSubNavItem={collapsibleSubNavItem}
                        {...otherProps}
                    >
                        {icon && (
                            <StyledIconWrapper>
                                <StyledIcon icon={icon} size="lg" />
                            </StyledIconWrapper>
                        )}
                        {title && (
                            <StyledTitleWrapper collapsedMenu={collapsedMenu} mobile={mobile}>
                                <StyledTitle
                                    subNavItem={subNavItem}
                                    collapsibleSubNavItem={collapsibleSubNavItem}
                                >
                                    {title}
                                </StyledTitle>
                            </StyledTitleWrapper>
                        )}
                    </StyledSideNavItem>
                ) : null
            }
        </SideNavContext.Consumer>
    );
};

SideNavItem.propTypes = {
    id: PropTypes.string,
    icon: PropTypes.node,
    title: PropTypes.node,
    selectable: PropTypes.bool,
    mobileNavItem: PropTypes.bool,
    mobileOnly: PropTypes.bool,
    subNavItem: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.node,
    collapsibleSubNavItem: PropTypes.bool,
};

/* istanbul ignore next */
SideNavItem.defaultProps = {
    id: '',
    title: '',
    selectable: true,
    mobileNavItem: false,
    mobileOnly: false,
    icon: '',
    subNavItem: false,
    onClick: () => null,
    children: null,
    collapsibleSubNavItem: false,
};

SideNavItem.Styles = Styles;
